"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUpsellDevice = exports.findChangeLosg = exports.filterOtherChangeLosgs = exports.getReportingInsuranceDetails = exports.getWaivedText = exports.getZipCode = exports.isAccessory = exports.getEditUrlForFirstNet = exports.getInsuranceDetails = exports.isAutoBillPayPromoAmount = exports.isAutoBillPaySelected = exports.isAutoBillPayEligible = exports.getPlanType = exports.getDeviceLineItem = exports.getHylaTradeInLineItem = exports.buildDeviceArray = exports.buildLineItemExtraParam = exports.buildShoppingContext = exports.buildTradeInRequest = exports.buildRemovePrepaidCartData = exports.getEditUrl = exports.showTVLaterBBExperience = exports.isMonthlySavings = exports.isDeviceMissing = exports.isRTIOSSDevice = exports.getSubscriberNumber = exports.displayStatusMessage = exports.isCommonDeliveryMethodAvailable = exports.isPrescreenNegativePricingDetailsDisplay = exports.getEffectivePromoPricing = exports.getExpUpLineItemName = exports.externalOrderSource = exports.isDownPaymentRequired = exports.removeDuplicatePromo = exports.getDeviceMakeModel = exports.getYourSavingsCardCmsData = exports.promoCyclePriceMsg = exports.multiUpCheck = exports.getExistingPlanName = exports.newLabelCheck = exports.ischangeRatePlanFlow = exports.getUpgradeLosgId = exports.hoverTextForEditAndRemoveIcon = exports.getDeviceHeader = exports.getLineNames = exports.getSavingsAndPromosCmsData = exports.getDealOffersCMSData = exports.getWlsCmsData = exports.filterLosgs = exports.isSimSwapFlag = exports.isEsimFlow = exports.isSimSwap = exports.isAppleWearableLineItem = exports.isBYODAndEsim = exports.isPayupLine = exports.isBYOD = exports.isHotspot = exports.getStandAlonePromotion = exports.isCaribbeanFlow = exports.showDevicePriceAndInfo = exports.getLineItemPriceData = exports.getBillingNote = exports.getFinalPrice = exports.setPriceForCommonCart = exports.getItemImage = exports.sortLogs = exports.organizeLineItems = void 0;
var CartUtilFunctions_1 = require("./CartUtilFunctions");
var Utils = require("./UtilityFunctions");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../cms/Cart.cms");
var WirelessCart_cms_1 = require("../components/CartLob/WirelessCart/WirelessCart.cms");
var SavingsAndPromos_cms_1 = require("../components/panels/SavingsAndPromos/SavingsAndPromos.cms");
var yourSavingsCard_cms_1 = require("../components/panels/PromoPanel/YourSavingsCard/yourSavingsCard.cms");
var CartActions_1 = require("../models/requests/CartActions");
var CartViewPanelProps_1 = require("../components/panels/CartViewPanel/CartViewPanelProps");
var cartUtil = require("./CartUtilFunctions");
var CommonUtilFuntions_1 = require("./CommonUtilFuntions");
var DealerOffers_cms_1 = require("../components/panels/RetailerOffer/DealerOffers.cms");
var UtilityFunctions_1 = require("./UtilityFunctions");
var LINE_ITEM_PRIORITY = ['DEVICE', 'SIM', 'MOBILEPLAN', 'MOBILEADDON', 'DATAPLAN', 'ATTNEXTUP_FEE', 'DOWNPAYMENT', 'ADVANCEPAYMENT', 'FEATURE',
    'ACTIVATION_FEE', 'ACTIVATIONFEE', 'TRADEIN', 'PAYUP', 'PAYOFF', 'UPGRADEFEE', 'ACCESSORY', 'SHAREDDATAGROUP',
    'SHAREDDATAFEATURE', 'VOICEPLAN'];
var LINE_ITEM_PRIORITY_FOR_MIX_AND_MATCH = ['DEVICE', 'DATAPLAN', 'ATTNEXTUP_FEE', 'SHAREDDATAGROUP',
    'SHAREDDATAFEATURE', 'DOWNPAYMENT', 'ADVANCEPAYMENT', 'FEATURE', 'ACTIVATION_FEE', 'ACTIVATIONFEE', 'TRADEIN', 'PAYUP',
    'PAYOFF', 'UPGRADEFEE', 'ACCESSORY', 'VOICEPLAN'];
var PRICE_TYPE_PRIORITY = ['DUE_UPON_FFL', 'DUE_NOW', 'DUE_NOW_ONETIME', 'RC'];
var BSSE_LINE_ITEM_PRIORITY = ['DEVICE', 'SIM', 'ACTIVATION_FEE', 'ACTIVATIONFEE', 'TRADEIN', 'PAYUP', 'PAYOFF',
    'UPGRADEFEE', 'MOBILEADDON', 'MOBILEPLAN', 'DATAPLAN', 'ATTNEXTUP_FEE', 'DOWNPAYMENT', 'ADVANCEPAYMENT',
    'FEATURE', 'ACCESSORY', 'SHAREDDATAGROUP', 'SHAREDDATAFEATURE', 'VOICEPLAN', 'ONETIMETAX'];
// This fuction is for if common cart (BSSE) flow
function organizeLineItems(lineItems, isMixAndMatch, losg) {
    var lineItemPriorty = LINE_ITEM_PRIORITY;
    var isCommonCart = Utils.isCommonCartPresent();
    if (isCommonCart && losg && losg.priceInfo && losg.priceInfo.dueTodayOneTimeTaxes &&
        losg.priceInfo.dueTodayOneTimeTaxes > 0) {
        var losgWlsOneTimeTax = {
            displayName: 'Estimated one-time sales tax',
            id: 'losg-wls-one-time-tax',
            itemType: 'ONETIMETAX',
            priceList: [
                {
                    amount: losg.priceInfo.dueTodayOneTimeTaxes,
                    baseAmount: losg.priceInfo.dueTodayOneTimeTaxes,
                    priceType: 'DUE_NOW_ONETIME',
                }
            ],
            uiDisplayLineItem: true,
        };
        lineItems.push(losgWlsOneTimeTax);
    }
    function shortItems(itemA, itemB) {
        return lineItemPriorty.indexOf(itemA.itemType.toUpperCase()) >
            lineItemPriorty.indexOf(itemB.itemType.toUpperCase()) ? 1 : -1;
    }
    function filterPriceType(items) {
        var nonRcPriceType = [];
        var rcPriceType = items.filter(function (item) {
            var priceType = item && item.priceList[0] && item.priceList[0].priceType && item.priceList[0].priceType.toUpperCase() || '';
            if (priceType === 'RC') {
                return true;
            }
            else {
                nonRcPriceType.push(item);
                return false;
            }
        });
        var allItems = __spreadArrays(nonRcPriceType, rcPriceType);
        return allItems;
    }
    if (lineItems && isCommonCart) {
        lineItemPriorty = BSSE_LINE_ITEM_PRIORITY;
        return filterPriceType(lineItems.sort(shortItems));
    }
    else if (lineItems && !isCommonCart) {
        lineItemPriorty = isMixAndMatch ? LINE_ITEM_PRIORITY_FOR_MIX_AND_MATCH : LINE_ITEM_PRIORITY;
        return lineItems.sort(shortItems);
    }
    else {
        return null;
    }
}
exports.organizeLineItems = organizeLineItems;
function sortLogs(losgA, losgB) {
    return losgA.sequence - losgB.sequence;
}
exports.sortLogs = sortLogs;
function getItemImage(lineItem, losg, isCommonCart) {
    var _a, _b, _c, _d, _e, _f, _g;
    var imgInfo = {};
    var imageUrl = '';
    var baseURL = window && window.location && window.location.protocol + "//" + window.location.host;
    var itemType = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var hardGood = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood;
    var deviceSubType = (_b = hardGood === null || hardGood === void 0 ? void 0 : hardGood.wirelessHardGoodCharacteristics) === null || _b === void 0 ? void 0 : _b._deviceSubType;
    var isEAPFlow = cartUtil.checkShareCartEligibilityForAndroid();
    if (lineItem && (itemType === 'DEVICE' || itemType === 'ACCESSORY')) {
        if (lineItem.hardGood && (lineItem.hardGood.hardGoodType === 'SIM') &&
            (((_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _c === void 0 ? void 0 : _c.make) !== 'Apple' && isEAPFlow)) {
            imageUrl = Utils.GET_ICON_SVG.P_SIM;
        }
        else if (((_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _d === void 0 ? void 0 : _d.make) !== 'Apple' && isEAPFlow && ((_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _e === void 0 ? void 0 : _e.productImageUrl)) {
            imageUrl = "" + baseURL + lineItem.hardGood.productImageUrl;
        }
        else if ((hardGood === null || hardGood === void 0 ? void 0 : hardGood.make) === 'Apple' && (deviceSubType === null || deviceSubType === void 0 ? void 0 : deviceSubType.toLowerCase()) === 'wearable') {
            imageUrl = ((_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _f === void 0 ? void 0 : _f.productImageUrl) ? "" + baseURL + lineItem.hardGood.productImageUrl :
                Utils.GET_ICON_SVG.SMARTWATCH_64;
        }
        else if (lineItem.aemProductImageUrl) {
            imageUrl = "" + baseURL + lineItem.aemProductImageUrl;
        }
        else if (lineItem.hardGood && lineItem.hardGood.productImageUrl) {
            imageUrl = "" + baseURL + lineItem.hardGood.productImageUrl;
        }
        else {
            imageUrl = baseURL + "/idpassets/global/devices/missing-image@2x.png";
        }
        if ((hardGood === null || hardGood === void 0 ? void 0 : hardGood.byodIndicator) && ((_g = hardGood === null || hardGood === void 0 ? void 0 : hardGood.wirelessHardGoodCharacteristics) === null || _g === void 0 ? void 0 : _g._simType) === 'eSIM') {
            imageUrl = Utils.GET_ICON_SVG.E_SIM;
        }
        imgInfo.imageUrl = imageUrl;
        imgInfo.imgAltText = lineItem.displayName ? lineItem.displayName : lineItem.itemType;
    }
    return imgInfo;
}
exports.getItemImage = getItemImage;
// This fuction is for if common cart (BSSE) flow
function setPriceForCommonCart(lineItem) {
    var lineItemPrice = lineItem;
    if (lineItem && lineItem.priceList && lineItem.itemType) {
        var itemType = lineItem.itemType.toUpperCase();
        for (var _i = 0, _a = lineItem.priceList; _i < _a.length; _i++) {
            var priceItem = _a[_i];
            lineItemPrice.price = priceItem;
            if ((itemType === 'MOBILEPLAN' || itemType === 'MOBILEADDON') && priceItem.priceType === 'RC') {
                break;
            }
            else if ((itemType === 'ACTIVATION_FEE' || itemType === 'ACTIVATIONFEE' ||
                itemType === 'MOBILEADDON' || itemType === 'ONETIMETAX')
                && (priceItem.priceType === 'DUE_NOW' || priceItem.priceType === 'DUE_NOW_ONETIME')) {
                break;
            }
            else if (itemType === 'DEVICE' && priceItem.priceType === 'DUE_UPON_FFL') {
                // Nothing to add here
            }
            else {
                lineItemPrice.price = {};
            }
        }
    }
    return lineItemPrice;
}
exports.setPriceForCommonCart = setPriceForCommonCart;
function getFinalPrice(price, itemType, isMixAndMatch, isCRPUpgrade) {
    var finalPrice = 0.00;
    var mixAndMatch = isMixAndMatch ? isMixAndMatch : false;
    if (price && price.baseAmount && price.amount) {
        if (price.baseAmount && price.baseAmount.toString() !== '0.00' &&
            (!mixAndMatch || itemType === 'ACTIVATION_FEE' || itemType === 'UPGRADEFEE' ||
                (Utils.isCommonCartPresent && itemType === 'MOBILEPLAN'))) {
            finalPrice = price.baseAmount;
        }
        else {
            finalPrice = price.amount;
        }
    }
    if (itemType === 'SHAREDDATAFEATURE' && isCRPUpgrade) {
        finalPrice = price.amount;
    }
    return finalPrice;
}
exports.getFinalPrice = getFinalPrice;
function getBillingNote(price) {
    var billingNote = '';
    if (price && price.priceType === 'RC') {
        billingNote = '/mo.';
    }
    return billingNote;
}
exports.getBillingNote = getBillingNote;
function getLineItemPriceData(lineItemObj, isMixAndMatch, isNotPrepaidCart, isCrpUpgrade) {
    var lineItem = lineItemObj;
    if (lineItem && lineItem.priceList) {
        lineItem = setPriceForCommonCart(lineItem);
    }
    var mixAndMatch = isMixAndMatch ? isMixAndMatch : false;
    var finalAmount = getFinalPrice(lineItem.price, lineItem.itemType, mixAndMatch, isCrpUpgrade);
    var billingNote = getBillingNote(lineItem.price);
    var lineItemPriceData = {
        lineItemPrice: { billingNote: billingNote, price: Number(finalAmount) },
        monthlyPayments: 0,
    };
    var contractDisplayName = (lineItem.contractDetails && lineItem.contractDetails.contractDisplayName) ?
        (lineItem.contractDetails.contractDisplayName).toLowerCase() : '';
    if (lineItem.contractDetails && (lineItem.contractDetails.contractType === 'LEASE' ||
        lineItem.contractDetails.contractType === 'INSTALLMENT')) {
        lineItemPriceData = {
            lineItemPrice: { billingNote: '/mo.', price: Number(lineItem.contractDetails.installmentAmount) },
            monthlyPayments: lineItem.contractDetails.contractLength,
        };
    }
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'ACCESSORY' && lineItem.price &&
        isNotPrepaidCart) {
        lineItemPriceData.lineItemPrice.price = Number(lineItem.price.total);
    }
    if (CartUtilFunctions_1.isSMBCustomer() && lineItem.contractDetails && lineItem.contractDetails.contractLength &&
        contractDisplayName && (contractDisplayName.indexOf('2 year') > -1) && isNotPrepaidCart) {
        lineItemPriceData = {
            lineItemPrice: { billingNote: '', price: Number(lineItem.price.amount) },
            monthlyPayments: lineItem.contractDetails.contractLength,
        };
    }
    return lineItemPriceData;
}
exports.getLineItemPriceData = getLineItemPriceData;
function showDevicePriceAndInfo(lineItem, losg, isCommonCart) {
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE' &&
        lineItem.hardGood && lineItem.hardGood.hardGoodType) {
        if (losg && losg.extraParams && losg.extraParams.BYOD && losg.extraParams.BYOD.toUpperCase() === 'TRUE' &&
            losg.extraParams.activation && losg.extraParams.activation.toUpperCase() === 'TRUE') {
            return false;
        }
        else if (lineItem.contractDetails && lineItem.contractDetails.contractType &&
            lineItem.contractDetails.contractType.toUpperCase() === 'NOCOMMIT') {
            return true;
        }
        else if (isCommonCart && lineItem.contractDetails && lineItem.contractDetails.contractType &&
            lineItem.contractDetails.contractType.toUpperCase() === 'ONETIME') {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
exports.showDevicePriceAndInfo = showDevicePriceAndInfo;
function isCaribbeanFlow() {
    var _a;
    var wlsCart = (_a = Utils.getCartResp()) === null || _a === void 0 ? void 0 : _a.wirelessCart;
    if (wlsCart === null || wlsCart === void 0 ? void 0 : wlsCart._fnCaribbeanOrder) {
        return true;
    }
    else {
        return false;
    }
}
exports.isCaribbeanFlow = isCaribbeanFlow;
function getStandAlonePromotion(losg) {
    var _a;
    var payload = Utils.getCartResp();
    var isStandAlonePromo = false;
    var promotionsList = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.promotions;
    if (promotionsList) {
        Object.values(losg.lineItems).forEach(function (lineItem) {
            promotionsList.forEach(function (promotion) {
                var _a, _b;
                if (((_a = promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'STANDALONE' && ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.promotionReferences) === null || _b === void 0 ? void 0 : _b.includes(promotion.id))) {
                    isStandAlonePromo = true;
                }
            });
        });
    }
    else {
        isStandAlonePromo = false;
    }
    return isStandAlonePromo;
}
exports.getStandAlonePromotion = getStandAlonePromotion;
function isHotspot(losg) {
    var isHotspotLosg = false;
    Object.values(losg.lineItems).forEach(function (lineItem) {
        var _a, _b;
        if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE' &&
            ((_b = (_a = lineItem._itemExtraAttributes) === null || _a === void 0 ? void 0 : _a.deviceCategory) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'USBCONNECT') {
            isHotspotLosg = true;
        }
    });
    return isHotspotLosg;
}
exports.isHotspot = isHotspot;
function isBYOD(losg) {
    var isByodLosg = false;
    Object.values(losg.lineItems).forEach(function (lineItem) {
        if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'HARDGOOD' &&
            lineItem.hardGood && lineItem.hardGood.byodIndicator) {
            isByodLosg = true;
        }
    });
    return isByodLosg;
}
exports.isBYOD = isBYOD;
function isPayupLine(losg) {
    var isPayupLosg = false;
    Object.values(losg.lineItems).forEach(function (lineItem) {
        if (lineItem && lineItem.itemType && (lineItem.itemType.toUpperCase() === 'PAYUP'
            || lineItem.itemType.toUpperCase() === 'TRADEIN')) {
            isPayupLosg = true;
        }
    });
    return isPayupLosg;
}
exports.isPayupLine = isPayupLine;
function isBYODAndEsim(losg) {
    var isBYODAndEsimLosg = false;
    if (losg) {
        Object.values(losg.lineItems).forEach(function (lineItem) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE' && ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _b === void 0 ? void 0 : _b.byodIndicator) &&
                ((_e = (_d = (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _c === void 0 ? void 0 : _c.wirelessHardGoodCharacteristics) === null || _d === void 0 ? void 0 : _d._simType) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase()) === 'esim' &&
                ((_h = (_g = (_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _f === void 0 ? void 0 : _f.wirelessHardGoodCharacteristics) === null || _g === void 0 ? void 0 : _g._deviceSubType) === null || _h === void 0 ? void 0 : _h.toLocaleLowerCase()) === 'smartphone') {
                isBYODAndEsimLosg = true;
            }
        });
    }
    else {
        var payload = Utils.getCartResp();
        if (CommonUtilFuntions_1.isKeyExist(payload, 'wirelessCart.losgs')) {
            Object.values(payload.wirelessCart.losgs).forEach(function (losgItem) {
                Object.values(losgItem.lineItems).forEach(function (lineItem) {
                    var _a, _b, _c, _d;
                    if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE' && ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _b === void 0 ? void 0 : _b.byodIndicator) &&
                        ((_d = (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _c === void 0 ? void 0 : _c.wirelessHardGoodCharacteristics) === null || _d === void 0 ? void 0 : _d._simType) === 'eSIM') {
                        isBYODAndEsimLosg = true;
                    }
                });
            });
        }
    }
    return isBYODAndEsimLosg;
}
exports.isBYODAndEsim = isBYODAndEsim;
function isAppleWearableLineItem(lineItem) {
    var _a, _b, _c, _d, _e, _f;
    var isAppleWearable = false;
    if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE' &&
        ((_d = (_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _b === void 0 ? void 0 : _b.wirelessHardGoodCharacteristics) === null || _c === void 0 ? void 0 : _c._deviceSubType) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === 'WEARABLE' &&
        ((_f = (_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _e === void 0 ? void 0 : _e.make) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === 'APPLE') {
        isAppleWearable = true;
    }
    return isAppleWearable;
}
exports.isAppleWearableLineItem = isAppleWearableLineItem;
function isSimSwap(losg) {
    var _a;
    var isSimSwapLosg = false;
    if (losg) {
        if (((_a = losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'PARK') {
            isSimSwapLosg = true;
        }
    }
    else {
        var payload = Utils.getCartResp();
        if (CommonUtilFuntions_1.isKeyExist(payload, 'wirelessCart.losgs')) {
            Object.values(payload.wirelessCart.losgs).forEach(function (losgItem) {
                var _a;
                if (((_a = losgItem.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'PARK') {
                    isSimSwapLosg = true;
                }
            });
        }
    }
    return isSimSwapLosg;
}
exports.isSimSwap = isSimSwap;
function isEsimFlow() {
    var payload = Utils.getCartResp();
    var eSimFlow = false;
    if (CommonUtilFuntions_1.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losgItem) {
            Object.values(losgItem === null || losgItem === void 0 ? void 0 : losgItem.lineItems).forEach(function (lineItem) {
                var _a, _b, _c;
                if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
                    if (((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem._itemExtraAttributes) === null || _b === void 0 ? void 0 : _b.simType) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'ESIM') {
                        eSimFlow = true;
                    }
                }
            });
        });
    }
    return eSimFlow;
}
exports.isEsimFlow = isEsimFlow;
function isSimSwapFlag() {
    var payload = Utils.getCartResp();
    var simSwapFlag = false;
    if (CommonUtilFuntions_1.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losgItem) {
            var _a;
            if (((_a = losgItem.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'PARK') {
                Object.values(losgItem === null || losgItem === void 0 ? void 0 : losgItem.lineItems).forEach(function (lineItem) {
                    var _a, _b, _c, _d, _e;
                    if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
                        if (((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem._itemExtraAttributes) === null || _b === void 0 ? void 0 : _b.simType) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'PSIM' ||
                            ((_e = (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _d === void 0 ? void 0 : _d.wirelessHardGoodCharacteristics) === null || _e === void 0 ? void 0 : _e._simType.toUpperCase()) === 'PSIM') {
                            simSwapFlag = true;
                        }
                    }
                });
            }
        });
    }
    return simSwapFlag;
}
exports.isSimSwapFlag = isSimSwapFlag;
function filterLosgs(losg) {
    var _a;
    if (((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'CHANGE') {
        return false;
    }
    return true;
}
exports.filterLosgs = filterLosgs;
function getWlsCmsData() {
    var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
    var cmsContent;
    if (cmsData && cmsData.wirelessCart.cartSummary) {
        cmsContent = cmsData.wirelessCart.cartSummary;
    }
    else {
        cmsContent = new WirelessCart_cms_1.WirelessCartSummaryCms();
    }
    return cmsContent;
}
exports.getWlsCmsData = getWlsCmsData;
function getDealOffersCMSData() {
    var cmsData = cms_integration_1.CMS.get(new DealerOffers_cms_1.DealerOffersCMS(), 'cartcheckout').content;
    var cmsContent;
    if (cmsData && cmsData.dealerOffers && cmsData.dealerOffers.offers) {
        cmsContent = cmsData.dealerOffers.offers;
    }
    else {
        cmsContent = new DealerOffers_cms_1.DealerOffersCMS().offers;
    }
    return cmsContent;
}
exports.getDealOffersCMSData = getDealOffersCMSData;
function getSavingsAndPromosCmsData() {
    var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
    var cmsContent;
    if (cmsData && cmsData.common.savingsAndPromos) {
        cmsContent = cmsData.common.savingsAndPromos;
    }
    else {
        cmsContent = new SavingsAndPromos_cms_1.SavingsAndPromosCms();
    }
    return cmsContent;
}
exports.getSavingsAndPromosCmsData = getSavingsAndPromosCmsData;
function getLineNames(losg, index, wlsCmsData, eapFlowContext, isMultiLine) {
    if (losg) {
        var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
        var lineNumber = ctnNumber ?
            (isMultiLine ? " " + (index + 1) + ' : ' + ("" + Utils.formatPhoneNumberWithDot(ctnNumber)) :
                ' : ' + ("" + Utils.formatPhoneNumberWithDot(ctnNumber))) : index + 1;
        var lineDisplayHeaderText = getDeviceHeader(lineNumber, losg, index + 1, wlsCmsData, eapFlowContext);
        if (losg.losgType.toUpperCase() === 'UP') {
            return "UPGRADE " + lineDisplayHeaderText;
        }
        else {
            return "" + lineDisplayHeaderText;
        }
    }
    else {
        return '';
    }
}
exports.getLineNames = getLineNames;
function getDeviceHeader(lineNumber, losg, index, wlsCmsData, eapFlowContext) {
    var wirelessCartCmsData = wlsCmsData;
    var lineDisplayHeaderText = wirelessCartCmsData.lineLabel + " " + index;
    var isFirstNet = CartUtilFunctions_1.isFNIntentPresent(losg);
    lineDisplayHeaderText = isFirstNet ? " FIRSTNET " + lineDisplayHeaderText : lineDisplayHeaderText;
    if (losg && losg.subscriberName && losg.subscriberName.firstName) {
        var lineName = losg.subscriberName.firstName.toUpperCase();
        lineDisplayHeaderText = isFirstNet ? lineName + "'S FIRSTNET " + wirelessCartCmsData.lineLabel :
            lineName + "'S " + wirelessCartCmsData.lineLabel;
    }
    if (losg && losg.losgType && losg.losgType.toUpperCase() === 'UP' && lineNumber) {
        if (losg.subscriberName && losg.subscriberName.firstName) {
            var lineName = losg.subscriberName.firstName.toUpperCase();
            lineDisplayHeaderText = lineName + "'S " + wirelessCartCmsData.lineLabel + lineNumber;
        }
        else {
            lineDisplayHeaderText = "" + wirelessCartCmsData.lineLabel + lineNumber;
        }
    }
    if (Utils.isAALFlow()) {
        if (losg && losg.subscriberName && losg.subscriberName.firstName) {
            var lineName = losg.subscriberName.firstName.toUpperCase();
            lineDisplayHeaderText = lineName + "'S " + wirelessCartCmsData.lineLabel;
        }
        else {
            lineDisplayHeaderText = wirelessCartCmsData.lineAALLabel + " " + index;
        }
    }
    if (eapFlowContext === null || eapFlowContext === void 0 ? void 0 : eapFlowContext.isEAPFlow) {
        if (eapFlowContext.simType === 'eSIM' || eapFlowContext.simType === 'pSIM') {
            lineDisplayHeaderText = wirelessCartCmsData.lineLabel + " " + index;
        }
        else {
            lineDisplayHeaderText = wirelessCartCmsData.lineEAPLabel;
        }
    }
    if (losg && losg.subscriberName && losg.subscriberName.firstName && CartUtilFunctions_1.isNewWirelessPostpaidView()) {
        var lineName = losg.subscriberName.firstName;
        var lineLabel = wirelessCartCmsData.lineLabel ? wirelessCartCmsData.lineLabel.toLowerCase() : '';
        lineDisplayHeaderText = isFirstNet ? lineName + "'s FIRSTNET " + lineLabel : lineName + "'s " + lineLabel;
    }
    return lineDisplayHeaderText;
}
exports.getDeviceHeader = getDeviceHeader;
function hoverTextForEditAndRemoveIcon(losgs, index) {
    var _a, _b;
    var hoverLineMsgForEditAndRemove;
    if (((_a = losgs === null || losgs === void 0 ? void 0 : losgs.subscriberName) === null || _a === void 0 ? void 0 : _a.firstName)) {
        hoverLineMsgForEditAndRemove = ((_b = losgs.subscriberName) === null || _b === void 0 ? void 0 : _b.firstName) + " Line";
    }
    else {
        hoverLineMsgForEditAndRemove = "Line" + index;
    }
    return hoverLineMsgForEditAndRemove;
}
exports.hoverTextForEditAndRemoveIcon = hoverTextForEditAndRemoveIcon;
function getUpgradeLosgId() {
    var _a;
    var payload = CartUtilFunctions_1.getWirelessCart();
    var upLosgId;
    Object.values((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs).forEach(function (losgData) {
        if (losgData.losgType === 'UP') {
            upLosgId = losgData.id;
        }
    });
    return upLosgId;
}
exports.getUpgradeLosgId = getUpgradeLosgId;
function ischangeRatePlanFlow() {
    var _a, _b, _c, _d;
    var payload = CartUtilFunctions_1.getWirelessCart();
    var currentDateValue = (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.planStartDate;
    var changeLosgData = {
        crpPlanName: '',
        crpPlanStartdate: currentDateValue,
        crpPrice: 0,
        isCrpCustomer: false,
    };
    Object.values((_d = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _d === void 0 ? void 0 : _d.losgs).forEach(function (losgData) {
        if ((losgData === null || losgData === void 0 ? void 0 : losgData.losgType) === 'CHANGE' && (losgData === null || losgData === void 0 ? void 0 : losgData.parentLosgId) &&
            getUpgradeLosgId() === (losgData === null || losgData === void 0 ? void 0 : losgData.parentLosgId)) {
            changeLosgData.isCrpCustomer = true;
            Object.values(losgData === null || losgData === void 0 ? void 0 : losgData.lineItems).forEach(function (lineItemData) {
                var _a, _b;
                if (((_a = lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'SHAREDDATAFEATURE') {
                    changeLosgData.crpPlanName = lineItemData.displayName;
                    changeLosgData.crpPrice = (_b = lineItemData.price) === null || _b === void 0 ? void 0 : _b.amount;
                }
            });
        }
    });
    return changeLosgData;
}
exports.ischangeRatePlanFlow = ischangeRatePlanFlow;
function newLabelCheck() {
    var _a;
    var payload = CartUtilFunctions_1.getWirelessCart();
    var crpNewLabelCheck = false;
    if (ischangeRatePlanFlow().isCrpCustomer) {
        Object.values((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs).forEach(function (losgData) {
            var _a;
            if ((((_a = losgData.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'CHANGE' && losgData.parentLosgId)) {
                crpNewLabelCheck = true;
            }
        });
    }
    return crpNewLabelCheck;
}
exports.newLabelCheck = newLabelCheck;
function getExistingPlanName() {
    var formattedplanDetails = {};
    var payload = CartUtilFunctions_1.getWirelessCart();
    if ((payload === null || payload === void 0 ? void 0 : payload.wirelessCart) && ischangeRatePlanFlow().isCrpCustomer) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losgData) {
            var _a;
            if ((((_a = losgData.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP')) {
                Object.values(losgData.lineItems).forEach(function (lineItem) {
                    if (lineItem && lineItem.itemType &&
                        lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP') {
                        formattedplanDetails.itemCategory = 'Package';
                        formattedplanDetails.itemHierarchy = 'Account level';
                        formattedplanDetails.itemName = lineItem.displayName;
                        formattedplanDetails.itemQty = 1;
                        formattedplanDetails.itemSku = lineItem.productSKU;
                        formattedplanDetails.itemSocCode = lineItem.billingCode;
                    }
                });
            }
        });
    }
    return formattedplanDetails;
}
exports.getExistingPlanName = getExistingPlanName;
function multiUpCheck() {
    var _a;
    var payload = CartUtilFunctions_1.getWirelessCart();
    var numberOfUpLosg = 0;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losgData) {
            var _a;
            if ((((_a = losgData.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP')) {
                ++numberOfUpLosg;
            }
        });
    }
    if (numberOfUpLosg > 1) {
        return true;
    }
    else {
        return false;
    }
}
exports.multiUpCheck = multiUpCheck;
function promoCyclePriceMsg(price, cycle, isPriceNegative) {
    var catoText = isPriceNegative ? 'negative dollar ' : 'dollar ';
    var promoCycleObj = {
        catoConten: catoText,
        suffix: '',
    };
    switch (cycle) {
        case 'QUATERLY':
            promoCycleObj.catoConten = catoText + price + ' per quaterly';
            promoCycleObj.suffix = '/qa.';
            break;
        case 'WEEKLY':
            promoCycleObj.catoConten = catoText + price + ' per weekly';
            promoCycleObj.suffix = '/wk.';
            break;
        case 'MONTHLY':
            promoCycleObj.catoConten = catoText + price + ' per month';
            promoCycleObj.suffix = '/mo.';
            break;
        case 'ONETIME':
        default:
            promoCycleObj.catoConten = catoText + price;
            promoCycleObj.suffix = '';
            break;
    }
    return promoCycleObj;
}
exports.promoCyclePriceMsg = promoCyclePriceMsg;
function getYourSavingsCardCmsData() {
    var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
    var cmsContent;
    if (cmsData && cmsData.common.yourSavings) {
        cmsContent = cmsData.common.yourSavings;
    }
    else {
        cmsContent = new yourSavingsCard_cms_1.YourSavingsCardCms();
    }
    return cmsContent;
}
exports.getYourSavingsCardCmsData = getYourSavingsCardCmsData;
function getDeviceMakeModel(lineItem) {
    var deviceInfo = {};
    if (lineItem && lineItem.itemType.toUpperCase() === 'DEVICE' && lineItem.hardGood) {
        deviceInfo = {
            capacity: lineItem.capacity || '',
            color: lineItem.color || '',
            make: lineItem.hardGood.make || '',
            model: lineItem.hardGood.model || '',
        };
    }
    return deviceInfo;
}
exports.getDeviceMakeModel = getDeviceMakeModel;
function removeDuplicatePromo(lineItem, promotions) {
    var promoList = [];
    lineItem.promotionReferences.forEach(function (promoRef, promoIndex) {
        var promoObj = promotions.find(function (promo) { return promo.id === promoRef; });
        if (promoObj) {
            if (promoIndex > 0) {
                var dp = promoList.find(function (promo) { return promo.promotionCode ?
                    promo.promotionCode === promoObj.promotionCode : false; });
                if (!dp) {
                    promoList.push(promoObj);
                }
            }
            else {
                promoList.push(promoObj);
            }
        }
    });
    return promoList;
}
exports.removeDuplicatePromo = removeDuplicatePromo;
function isDownPaymentRequired(losg, isExpressUp) {
    var downPayment = {
        downPaymentItem: {},
        isDownPayment: false,
    };
    if (losg && losg.length > 0) {
        losg.forEach(function (losgData) {
            var losgItems = Object.values(losgData.lineItems);
            var lineItemId;
            losgItems.forEach(function (lineItem) {
                if (lineItem && lineItem.uiDisplayLineItem && lineItem.contractDetails &&
                    lineItem.contractDetails.downPayment > 0) {
                    downPayment.isDownPayment = true;
                    lineItemId = lineItem.id;
                }
                if (downPayment.isDownPayment && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DOWNPAYMENT'
                    && lineItemId !== undefined) {
                    downPayment.downPaymentItem[lineItemId] = lineItem;
                }
            });
        });
    }
    return downPayment;
}
exports.isDownPaymentRequired = isDownPaymentRequired;
function externalOrderSource(payload) {
    if (payload && payload.wirelessCart && payload.wirelessCart.externalOrderSource) {
        return payload.wirelessCart.externalOrderSource.toUpperCase();
    }
    else {
        return null;
    }
}
exports.externalOrderSource = externalOrderSource;
function getExpUpLineItemName(lineItem) {
    var deviceName = '';
    var deviceCapacity = lineItem && lineItem.capacity ? "- " + lineItem.capacity : '';
    if (lineItem && lineItem.itemType.toLowerCase() === 'device' && lineItem.hardGood && lineItem.hardGood.make
        && lineItem.hardGood.model) {
        deviceName = lineItem.hardGood.make + " " + lineItem.hardGood.model + " - " + lineItem.color + " " + deviceCapacity;
    }
    else {
        deviceName = lineItem.displayName + " - " + lineItem.color + " " + deviceCapacity;
    }
    return deviceName;
}
exports.getExpUpLineItemName = getExpUpLineItemName;
function getEffectivePromoPricing(lineItem) {
    var bogoPricingInfo = CartUtilFunctions_1.getEffectivePricing(lineItem);
    if (bogoPricingInfo && bogoPricingInfo.isPromoLineItem &&
        lineItem.effectiveMonthlyAmount && lineItem.effectiveMonthlyAmount !== 0.0 &&
        lineItem.contractDetails.downPayment > 0) {
        bogoPricingInfo.effectiveDevicePrice = lineItem.effectiveMonthlyAmount;
    }
    return bogoPricingInfo;
}
exports.getEffectivePromoPricing = getEffectivePromoPricing;
function isPrescreenNegativePricingDetailsDisplay(payload) {
    return payload && payload.enablePrescreenNegativePricingDetailsDisplay || false;
}
exports.isPrescreenNegativePricingDetailsDisplay = isPrescreenNegativePricingDetailsDisplay;
function isCommonDeliveryMethodAvailable(payload) {
    return Utils.isEnableValidateInventory() && payload && payload.wirelessCart &&
        payload.wirelessCart.deliveryMethods &&
        payload.wirelessCart.deliveryMethods.length > 0 || false;
}
exports.isCommonDeliveryMethodAvailable = isCommonDeliveryMethodAvailable;
function displayStatusMessage(fulfillmentOptions) {
    var message;
    if (fulfillmentOptions && fulfillmentOptions.skuFulfillmentInfos) {
        fulfillmentOptions.skuFulfillmentInfos.forEach(function (items) {
            if (items && items.statusMessage) {
                message = items.statusMessage;
            }
        });
    }
    return message || '';
}
exports.displayStatusMessage = displayStatusMessage;
function getSubscriberNumber(losg) {
    var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
    return (losg.losgType.toUpperCase() === 'UP' && ctnNumber) ? ctnNumber : '';
}
exports.getSubscriberNumber = getSubscriberNumber;
function isRTIOSSDevice(payload) {
    return !!(payload && payload.wirelessCart && payload.wirelessCart.insufficientRequestedQty);
}
exports.isRTIOSSDevice = isRTIOSSDevice;
function isDeviceMissing(losg) {
    var isDevice = false;
    if (losg && losg.requiredToCheckout) {
        Object.values(losg.requiredToCheckout).forEach(function (incompletePart) {
            if (incompletePart === 'WLS_DEVICE') {
                isDevice = true;
            }
        });
    }
    return isDevice;
}
exports.isDeviceMissing = isDeviceMissing;
function isMonthlySavings() {
    var payload = Utils.getCartResp();
    if (payload && (payload.wirelessCart || payload.commonCart)) {
        var isCommonCart = (payload && payload.commonCart) ? true : false;
        var mixAndMatch = !!(payload.wirelessCart && payload.wirelessCart.mixAndMatch);
        var currentFlowType = Utils.getCurrentFlowType();
        var isAALCart = (currentFlowType === 'AL_WIRELESS' || currentFlowType === 'AAL_WIRELESS') ? true : false;
        var isMixedCart = currentFlowType === 'UP_AL_WIRELESS' ? true : false;
        if (isCommonCart && UtilityFunctions_1.isAALFlow()) {
            return true;
        }
        else if ((isAALCart || isMixedCart) && mixAndMatch && !CartUtilFunctions_1.isSMBCustomer()) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
exports.isMonthlySavings = isMonthlySavings;
function showTVLaterBBExperience() {
    var payload = Utils.getCartResp();
    return payload === null || payload === void 0 ? void 0 : payload.showTVLaterBBExperience;
}
exports.showTVLaterBBExperience = showTVLaterBBExperience;
function getEditUrl(cartData, cartMetaData, losg) {
    var editUrl = cartData && cartData._cartCreationSource &&
        cartData._cartCreationSource === 'PSC' && losg && losg.pscEditUrl
        ? losg.pscEditUrl : cartMetaData && cartMetaData.editUrl ?
        cartMetaData.editUrl : '';
    return editUrl;
}
exports.getEditUrl = getEditUrl;
function buildRemovePrepaidCartData(losgId, lineItem, cartCreationSource, paymentType) {
    var removeCartRequest = {
        itemsList: [
            {
                action: CartActions_1.ActionType.REMOVE,
                commitmentTerm: lineItem && lineItem.contractDetails &&
                    lineItem.contractDetails.installmentPlanDefinition || '',
                contractLength: lineItem && lineItem.contractDetails && lineItem.contractDetails.contractLength,
                contractType: lineItem && lineItem.contractDetails && lineItem.contractDetails.contractType || '',
                itemType: CartActions_1.ItemType.DEVICE,
                losgId: losgId,
                losgType: 'NEW',
                productGroup: CartActions_1.ProductGroupType.WIRELESS,
                quantity: 1,
            },
        ],
        serviceContext: {
            srcSystem: 'IDSE',
        },
        shoppingContext: {
            cartCreationSource: cartCreationSource,
            paymentType: paymentType || '',
        },
    };
    return removeCartRequest;
}
exports.buildRemovePrepaidCartData = buildRemovePrepaidCartData;
function buildTradeInRequest(losg, actionType, cartCreationSource, isNewTradein, offerCode, modalData) {
    var lineItemId = '';
    var skuId = '';
    var contractLength;
    var commitmentTerm = '';
    var offerId = '';
    var isCaribbeanUser = isCaribbeanFlow();
    Object.values(losg.lineItems).forEach(function (lineItem) {
        if (lineItem.itemType.toUpperCase() === 'DEVICE') {
            lineItemId = lineItem.id;
            skuId = lineItem.productSKU;
            contractLength = lineItem.contractDetails.contractLength;
            commitmentTerm = lineItem.contractDetails.installmentPlanDefinition;
            offerId = lineItem.productCode;
        }
    });
    var tradeInIndicator = actionType === 'ADD' ? true : false;
    var addTocartRequest = {
        hylaTradeInIntentIndicator: tradeInIndicator,
        itemsList: [
            {
                action: CartActions_1.ActionType.MODIFY,
                commitmentTerm: commitmentTerm,
                continueCurrentCart: false,
                contractLength: contractLength,
                itemId: lineItemId,
                itemType: CartActions_1.ItemType.DEVICE,
                losgId: losg.id,
                losgType: losg.losgType,
                offerId: offerId,
                productGroup: CartActions_1.ProductGroupType.WIRELESS,
                productSKU: skuId,
                quantity: 1,
            },
        ],
        serviceContext: {
            srcSystem: 'IDSE',
        },
        shoppingContext: {
            cartCreationSource: cartCreationSource,
            hylaTradeInIntentRejected: !tradeInIndicator,
        },
    };
    if (offerCode) {
        addTocartRequest.shoppingContext.offerCode = offerCode;
    }
    if (CartUtilFunctions_1.isFNIntentPresent()) {
        addTocartRequest.shoppingContext.fnIntendInd = true;
    }
    if (CartUtilFunctions_1.isFNUserWithConsumerLine()) {
        addTocartRequest.shoppingContext.firstNetUser = true;
    }
    if (isCaribbeanUser) {
        addTocartRequest.shoppingContext.fnCaribbean = true;
    }
    if (isNewTradein) {
        addTocartRequest.shoppingContext.hylaTradeInInfo = {
            capacity: modalData.capacity,
            modelPrice: modalData.modelPrice,
            modelcode: modalData.modelCode,
            questions: modalData.questionAnswers,
            tradeInDeviceCondition: modalData.tradeInDeviceCondition,
        };
        addTocartRequest.shoppingContext.hylaImageUrl = modalData.image;
        addTocartRequest.shoppingContext.make = modalData.make;
        addTocartRequest.shoppingContext.model = modalData.productFamily;
        addTocartRequest.shoppingContext.hylaDiscountAmount = modalData.hylaDiscountAmount;
        addTocartRequest.shoppingContext.sku = modalData.sku;
        if (modalData === null || modalData === void 0 ? void 0 : modalData.imei) {
            addTocartRequest.shoppingContext.imei = "" + modalData.imei;
        }
    }
    return addTocartRequest;
}
exports.buildTradeInRequest = buildTradeInRequest;
function buildShoppingContext(payload, losgType) {
    var _a, _b, _c, _d, _e;
    var cartSource = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a._cartCreationSource;
    var isCommonCart = !!(payload && payload.commonCart);
    var shoppingContextObj = {
        cartCreationSource: cartSource,
    };
    if (isCommonCart) {
        shoppingContextObj.billingSystemId = 'R';
        if (losgType === 'AL') {
            shoppingContextObj.customerId = (_c = (_b = payload.commonCart) === null || _b === void 0 ? void 0 : _b.account) === null || _c === void 0 ? void 0 : _c.customerId;
            shoppingContextObj.individualId = (_e = (_d = payload.commonCart) === null || _d === void 0 ? void 0 : _d.account) === null || _e === void 0 ? void 0 : _e.individualId;
        }
    }
    else {
        shoppingContextObj.actionType = '';
        shoppingContextObj.paymentType = '';
        if (CartUtilFunctions_1.isFNIntentPresent()) {
            shoppingContextObj.fnIntendInd = true;
        }
        if (CartUtilFunctions_1.isFNUserWithConsumerLine()) {
            shoppingContextObj.firstNetUser = true;
        }
    }
    return shoppingContextObj;
}
exports.buildShoppingContext = buildShoppingContext;
function buildLineItemExtraParam(payload, losgId) {
    var _a, _b, _c, _d;
    var losgObj = (_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs[losgId];
    var itemExtraParamObj = {
        accountId: '',
        primaryPlanSubscriber: '',
        productRootId: '',
    };
    if (losgObj && losgObj.losgType === 'AL') {
        itemExtraParamObj.productRootId = losgObj.bundleGroupId;
        itemExtraParamObj.accountId = (_c = (_b = payload.commonCart) === null || _b === void 0 ? void 0 : _b.account) === null || _c === void 0 ? void 0 : _c.accountId;
        itemExtraParamObj.primaryPlanSubscriber = (_d = losgObj.wirelessLOSCharacteristics) === null || _d === void 0 ? void 0 : _d.primaryPlanSubscriber;
    }
    else {
        itemExtraParamObj.productRootId = undefined;
        itemExtraParamObj.accountId = undefined;
        itemExtraParamObj.primaryPlanSubscriber = undefined;
    }
    return itemExtraParamObj;
}
exports.buildLineItemExtraParam = buildLineItemExtraParam;
function buildDeviceArray(cartpayload) {
    var payload = cartpayload ? cartpayload : Utils.getCartResp();
    var deviceRequest = {};
    if (payload.wirelessCart.losgs) {
        var losgValues = Object.values(payload.wirelessCart.losgs);
        losgValues.sort(sortLogs);
        var filteredLosgsData = losgValues.filter(filterLosgs);
        var losgKey_1;
        filteredLosgsData.forEach(function (losg) {
            var losgItems = organizeLineItems(Object.values(losg.lineItems), true, losg);
            var deviceLineItem;
            losgKey_1 = losg.id;
            losgItems.forEach(function (lineItem) {
                var _a, _b, _c;
                if (((_a = lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
                    deviceLineItem = lineItem;
                    deviceRequest[losgKey_1] = {
                        commitmentTerm: (_c = (_b = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.contractDetails) === null || _b === void 0 ? void 0 : _b._commitmentTermId) === null || _c === void 0 ? void 0 : _c.toString(),
                        skuId: deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU,
                    };
                }
            });
        });
    }
    return deviceRequest;
}
exports.buildDeviceArray = buildDeviceArray;
function getHylaTradeInLineItem(losg) {
    var hylaTradeInLine;
    var losgItems = organizeLineItems(Object.values(losg.lineItems), true, losg);
    losgItems.forEach(function (lineItem) {
        var _a;
        if (((_a = lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'HYLA_TRADEIN') {
            hylaTradeInLine = lineItem;
        }
    });
    return hylaTradeInLine;
}
exports.getHylaTradeInLineItem = getHylaTradeInLineItem;
function getDeviceLineItem(losg) {
    var devicelineItem;
    var losgItems = organizeLineItems(Object.values(losg.lineItems), true, losg);
    losgItems.forEach(function (lineItem) {
        var _a;
        if (((_a = lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
            devicelineItem = lineItem;
        }
    });
    return devicelineItem;
}
exports.getDeviceLineItem = getDeviceLineItem;
function getPlanType(cart) {
    return Object.values(cart.losgs)[0].losgType.toUpperCase() === 'CHANGE' ?
        CartViewPanelProps_1.PlanType.WIRELESS_CRP : CartViewPanelProps_1.PlanType.WIRELESS;
}
exports.getPlanType = getPlanType;
function isAutoBillPayEligible() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    return (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.autoPayEligible;
}
exports.isAutoBillPayEligible = isAutoBillPayEligible;
function isAutoBillPaySelected() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    return (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.autoPaySelected;
}
exports.isAutoBillPaySelected = isAutoBillPaySelected;
function isAutoBillPayPromoAmount() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    return (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.abpPromotionAmount;
}
exports.isAutoBillPayPromoAmount = isAutoBillPayPromoAmount;
function getInsuranceDetails() {
    var sessionStorage = window.sessionStorage;
    var cartItems = sessionStorage.getItem('insurance-details');
    return cartItems;
}
exports.getInsuranceDetails = getInsuranceDetails;
function getEditUrlForFirstNet() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    return (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.editUrl;
}
exports.getEditUrlForFirstNet = getEditUrlForFirstNet;
function isAccessory(losgType, cartCreationSource, isAALFlows) {
    return (losgType.toUpperCase() !== 'UP' && !isAALFlows &&
        cartCreationSource === 'PSC') ? true : false;
}
exports.isAccessory = isAccessory;
function getZipCode(cookieVals) {
    var cookieVal = Utils.getCookie(cookieVals);
    var decodedCookie = cookieVal.split('|');
    var newdecodedCookie = '';
    decodedCookie.forEach(function (val) {
        var c = val;
        if (c.includes('zip') || c.includes('zipCode')) {
            var zipVal = c.substring(c.indexOf('=') + 1, c.length);
            newdecodedCookie = zipVal;
        }
    });
    return newdecodedCookie;
}
exports.getZipCode = getZipCode;
// tslint:disable-next-line: no-any
function getWaivedText(id, b2bDetail) {
    if (b2bDetail.FAN) {
        if (id === 'UPG') {
            return 'Waived Upgrade Fee';
        }
        else {
            return getWlsCmsData().iruActivationFeeWaiver;
        }
    }
    else {
        if (id === 'UPG') {
            return '$0 upgrade fee for online orders';
        }
        else {
            return getWlsCmsData().activationFeeWaiver;
        }
    }
}
exports.getWaivedText = getWaivedText;
function getReportingInsuranceDetails(insuranceDetails) {
    var _a, _b;
    var accountLevel = [];
    if (insuranceDetails === null || insuranceDetails === void 0 ? void 0 : insuranceDetails.isAccLevelInsurance) {
        accountLevel = [
            {
                itemCategory: 'Insurance',
                itemHierarchy: 'Account Level',
                itemName: (_a = insuranceDetails === null || insuranceDetails === void 0 ? void 0 : insuranceDetails.accLevelInsuranceDetails) === null || _a === void 0 ? void 0 : _a.displayName,
                itemQty: 1,
                itemSku: (_b = insuranceDetails === null || insuranceDetails === void 0 ? void 0 : insuranceDetails.accLevelInsuranceDetails) === null || _b === void 0 ? void 0 : _b.skuId,
            },
        ];
    }
    var subscriberFeaturesObject = insuranceDetails === null || insuranceDetails === void 0 ? void 0 : insuranceDetails.subscriberFeatures;
    var SubscriberArray = [];
    for (var key in subscriberFeaturesObject) {
        if (subscriberFeaturesObject.hasOwnProperty(key)) {
            if (subscriberFeaturesObject[key].isInsurance) {
                SubscriberArray.push({
                    itemCategory: 'Insurance',
                    itemHierarchy: 'Subscriber Level',
                    itemName: subscriberFeaturesObject[key].displayName,
                    itemQty: 1,
                    itemSku: subscriberFeaturesObject[key].skuId,
                    itemSocCode: subscriberFeaturesObject[key].insuranceBillCode,
                });
            }
        }
    }
    var formattedInsuranceDetails = accountLevel.concat(SubscriberArray);
    return formattedInsuranceDetails;
}
exports.getReportingInsuranceDetails = getReportingInsuranceDetails;
function filterOtherChangeLosgs(losgs) {
    var upgradeCTN = '';
    var filteredLosgsData = [];
    if (losgs) {
        Object.values(losgs).forEach(function (losg) {
            var _a, _b, _c;
            if (((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'CHANGE') {
                filteredLosgsData.push(losg);
            }
            if (((_b = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'UP') {
                upgradeCTN = (_c = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _c === void 0 ? void 0 : _c.associatedCtn;
            }
        });
    }
    return filteredLosgsData.filter(function (cLosg) { var _a; return (((_a = cLosg === null || cLosg === void 0 ? void 0 : cLosg.extraParams) === null || _a === void 0 ? void 0 : _a.associatedCtn) !== upgradeCTN); });
}
exports.filterOtherChangeLosgs = filterOtherChangeLosgs;
function findChangeLosg(losgs, upgradeCTN) {
    var changeLosgData;
    if (losgs && upgradeCTN) {
        Object.values(losgs).forEach(function (losg) {
            var _a, _b;
            if (((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'CHANGE' && ((_b = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _b === void 0 ? void 0 : _b.associatedCtn) === upgradeCTN) {
                changeLosgData = losg;
            }
        });
    }
    return changeLosgData;
}
exports.findChangeLosg = findChangeLosg;
function isUpsellDevice(cartData, losgId) {
    if (cartData === null || cartData === void 0 ? void 0 : cartData.losgs) {
        return Object.values(cartData === null || cartData === void 0 ? void 0 : cartData.losgs).filter(function (tLosg) {
            var _a, _b;
            return ((_a = tLosg === null || tLosg === void 0 ? void 0 : tLosg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'AL' &&
                ((_b = tLosg === null || tLosg === void 0 ? void 0 : tLosg._upsellLosgId) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === (losgId === null || losgId === void 0 ? void 0 : losgId.toUpperCase());
        }).length > 0 || false;
    }
    return false;
}
exports.isUpsellDevice = isUpsellDevice;
//# sourceMappingURL=WirelessUtilFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/utils/WirelessUtilFunctions.js
// module id = 28
// module chunks = 8